import React, { Component } from 'react';

class Regulations extends Component {
    constructor(props) {
        super(props);
        this.state = { accepted:false  }
    }
    handleSubmitClick(e){
        e.preventDefault();
        this.props.handleSubmitClick();
    }
    handleBackClick(){
        this.props.handleBackClick();
    }
    render() { 
        return ( 
        <div className="kwizda-regulations">
            <h1>Részvételi feltételek és Adatkezelési tájékoztató</h1>
            <div> 
                <h4>Részvételi feltételek</h4>
                    <p>A <b>Muchmore Korlátolt Felelősségű Társaság </b> 
                        (székhely: 1137 Budapest, Erdőalja út 113/a, cégjegyzékszám: 01 09 993113; adószám: 24156387-2-41; a továbbiakban: Muchmore)
                        által szervezett „Nézzük bióban <b>Kertészeti teszt program</b>-ban (a továbbiakban: Program)
                        most ingyen próbálhatja ki bio termékeinket, melynek dokumentálását követően garantált ajándékokban is részesül!
                    </p>
                    <p>A Programban az alábbi termékek ingyenes kipróbálására (tesztelés) nyílik lehetőség:</p>
                    <table className="kwizda-regulations-table" style={{width:'100%'}}>
                        <thead>
                            <tr>
                                <th>Kísérlet</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Leanderen kártevők elleni kísérletünkben - egy konvencionális, olajos rovarölő szert hasonlítjuk össze a Boraqua narancsterpénes készítménnyel </td>
                            </tr>
                            <tr>
                                <td>Biodinamikus őszi és tavaszi saláta fóliás kísérletünkben - a vegyszermentes Lollo Bionda tépősalátát hasonlítunk össze a biodinamikus nemesítésű verziójával</td>
                            </tr>
                            <tr>
                                <td>Biodinamikus petrezselyem kísérletünkben vegyszermentes félhosszú petrezselymet hasonlítunk össze a biodinamikus nemesítésű verziójával - </td>
                            </tr>
                            <tr>
                                <td>Tiszafa hajtásnövelés kísérletünkben egy baktériumkeverék és az Amazon célzott mikrobiológiai készítmény hatását teszteljük a tiszafa hajtásainak növekedésére - </td>
                            </tr>
                            <tr>
                                <td>Fűkomposztálás gyorsítás kísérletünkben egy baktériumkeverék és az AgriN célzott mikrobiológiai készítmény hatását teszteljük a komposztálás javítására- </td>
                            </tr>
                            <tr>
                                <td>Huminsavas sárgarépa kísérletünkben a Kelaterra GR hatását vizsgáljuk a sárgarépa mennyiségi és minőségi mutatóira. - </td>
                            </tr>
                            <tr>
                                <td>Leanderen virágzás növelési kísérletünkben egy baktériumkeverék és az Amazon célzott mikrobiológiai készítmény hatását teszteljük a virágbimbók képződésére és a virágzás idejére vonatkozóan- </td>
                            </tr>
                        </tbody>
                    </table>
                    <br/>
                    <br/>
                    <p>A termékek tesztelésének időintervalluma: 2025. március 1 és augusztus 31. között.</p>
                    <p>A Programba történő regisztráció határideje:</p>
                    <table className="kwizda-regulations-table">
                        <thead>
                            <tr>
                                <th>Kísérlet</th>
                                <th>Regisztráció határideje</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Leanderen kártevők elleni kísérlet</td>
                                <td>2025. 06. 15.</td>
                            </tr>
                            <tr>
                                <td>Biodinamikus őszi és tavaszi saláta fóliás kísérlet</td>
                                <td>2025. 03. 10.</td>
                            </tr>
                            <tr>
                                <td>Biodinamikus petrezselyem kísérlet</td>
                                <td>2025. 03. 10.</td>
                            </tr>
                            <tr>
                                <td>Tiszafa hajtásnövelés kísérlet</td>
                                <td>2025. 04. 15.</td>
                            </tr>
                            <tr>
                                <td>Fűkomposztálás gyorsítás kísérlet</td>
                                <td>2025. 05. 15.</td>
                            </tr>
                            <tr>
                                <td>Huminsavas sárgarépa kísérlet</td>
                                <td>2025. 03. 15.</td>
                            </tr>
                            <tr>
                                <td>Leanderen virágzás növelési kísérlet</td>
                                <td>2025. 04. 15.</td>
                            </tr>
                        </tbody>
                    </table>
                    <br/>
                    <p>
                        <b>A Muchmore a regisztrált jelentkezők közül választja ki azokat, akik részt vehetnek az termékek ingyenes tesztelésben.</b></p>
                    <p>A Programba azok a kiskert tulajdonosok regisztrálhatnak, akik a regisztrációkor már a kiírásnak megfelelő növényekkel és helyszínnel rendelkeznek. 
                        A tesztelésre kiválasztott jelentkezők az adott kísérlet leírásának megfelelően kell eljárniuk és dokumentációt készíteniük.</p>
                    <p>A Programba a <a className="kwizda3-link" href="https://www.nezzukbioban.hu">www.nezzukbioban.hu</a> <b>weboldalon</b> a regisztrációs adatlap kitöltésével lehet regisztrálni.</p>
                    
                    <p>A regisztráció során az egyéb adatok mellett a jelentkezőknek 3 db képet is fel kell tölteniük a regisztrációs felületre,
                         melyek a kísérleti helyszínük állapotát mutatják be.
                    </p>
                    <p>A regisztrációval a jelentkező elfogadja a Részvételi Feltételeket és 
                    vállalja a benne foglalt kötelezettségek teljesítését.</p>

                <h4>A Programba kiválasztott jelentkezőknek az alábbi szakmai kötelezettségek terhelik:</h4>
                <ul>
                    <li>a regisztrációban megjelölt termesztési helyszín biztosítása, annak egyoldalú módosítása tilos</li>
                    <li>a tesztelendő termék adott kísérleti leírásnak megfelelő felhasználása</li>
                    <li>a Muchmore által megadott kísérleti protokoll betartása</li>
                    <li>szakszerű vetés, termesztés, betakarítás biztosítása</li>
                    <li>a tesztelt terület elkülönült kezelése és a termés elkülönült számbavételének biztosítása</li>
                </ul>
                <h4>A Programba kiválasztott jelentkezőket az alábbi kommunikációs kötelezettségek terhelik:</h4>
                <ul>
                    <li>a megadott email címre a fotó dokumentáció kísérleti dokumentációnak megfelelő beküldése, megadott határidők szerint</li>
                    <li>a szervező igénye esetén rövid videó interjú biztosítása a kísérleti tapasztalatok beszámolójával, a jelenetkező által megadott helyszínen</li>
                </ul>
                <h4>Kizárólag a Muchmore jogosult</h4>
                <ul>
                    <li>kiválasztani a Programba regisztráló termelők közül azokat, akik részt vehetnek a tesztelésben</li>
                    <li>meghatározni a tesztelésben résztvevő helyszínek számát</li>
                    <li>kizárni a jelentkezőt a Programból a Részvételi Feltételek megsértése esetén</li>
                    <li>meghatározni a termelőktől elvárt dokumentáció formáját, eszközét, gyakoriságát.</li>
                </ul>
                <p>A Muchmore a jelentkezési határidőt követő 7 napon belül email-ben értesíti azokat a helyszín tulajdonosokat, 
                akiket a regisztrált jelentkezők közül a tesztelésre kiválasztott. 
                A tesztelésre ki nem választott regisztrálók értesítése ugyanilyen módon és határidőben történik.
                </p>
                <p>A Muchmore saját költségén eljuttatja a tesztelésre kiválasztott jelentkezőkhöz a regisztráció során általuk kiválasztott terméket,
                a regisztrációban megadott mennyiségben. A Muchmore szaktanácsadója a tenyészidőszak során 
                a termelő kérésére indokolt esetben személyes konzultációt biztosít a termesztési helyen.
                </p>
                <h4>Adatkezelési tájékoztató</h4>
                <p>A Programban részt venni kívánó jelentkező a regisztráció keretében megadja a nevét, elérhetőségét (telefonszámát és email címét, lakcímét).
                </p>
                <p>Az adatszolgáltatás önkéntes és a jeletkező hozzájárulásán alapul; adatok megadásával a jelentkező tudomásul veszi,
                hogy a Muchmore a Program megvalósítása céljára kezeli és feldolgozza a regisztráció során megadott adatait.
                A Muchmore az általa Programban való részvételre kiválasztott termelők adatait a Program időtartama alatt, de legfeljebb 2025. december 31-ig kezeli. 
                A Programban való részvételre ki nem választott jelentkezők adatait a Muchmore semmilyen további célra nem használja fel és 2025. szeptember 30-ig törli.
                A termelők adatait a Muchmore kutatási célra további harmadik személyeknek átadhatja.
                </p>
                <p>A Muchmore kötelezettséget vállal arra, hogy a jelentkezők személyes adatait a hatályos jogszabályi rendelkezésekre figyelemmel,
                az információs önrendelkezési jogról és az információszabadságról szóló 2011. évi CXII. tv-ben foglaltaknak megfelelően kezeli.
                </p>
                <p>A termelők a Muchmore-tól bármikor tájékoztatást kérhetnek személyes adataik kezeléséről, 
                továbbá kérhetik személyes adataik helyesbítését. 
                A tájékoztatást a Muchmore a kérelem kézhezvételétől számított legrövidebb időn belül, 
                de legfeljebb 30 napon belül írásban vagy elektronikus úton küldi meg az érintettnek. 
                A jelentkező jogosult kérni személyes adatai törlését 
                (azaz visszavonni a személyes adatai kezeléséhez történő hozzájárulást tartalmazó nyilatkozatát).
                A törlés postai úton kérhető a Muchmore-tól. 
                A termelő bármikor visszavonhatja a már megadott hozzájárulását, indokolás nélkül,
                részben vagy egészben. A Muchmore a hozzájárulás visszavonásáról történt értesítés kézhezvételét követően haladéktalanul gondoskodik az adatkezelés megszüntetéséről, 
                véglegesen törli a termelőt a nyilvántartásából, és a visszavonással érintett személyes adatok törlésre kerülnek oly módon,
                hogy a visszavonó nyilatkozatot tevő személy egyértelműen azonosítható legyen, majd mindezek megtörténtéről értesíti a jelentkezőt.
                A kezelt adatok a törlési kérelmet követő 8 napon belül törlésre kerülnek a Muchmore adatbázisából.
                </p>
                <p>A személyes adatok törlésével a termelő részvétele a Programban megszűnik.</p>
                <p>
                A termelő az adatkezeléssel, vagy annak megszüntetésével kapcsolatos
                bármilyen kérdéssel a <a className="kwizda3-link" href="mailto:office@muchmore.hu">office@muchmore.hu</a> e-mail címen vagy a Muchmore Kft. - 1137 Budapest,
                Erdőalja út 113/a címen fordulhat a Muchmore-hoz.
                </p>
            </div>    
            <hr/>
                {!this.props.displayOnly &&
                <div style={{marginBottom:30}}>                   
                    <button 
                        type="submit"
                        className="kwizda-button"
                        onClick={(e)=>this.handleSubmitClick(e)}
                    >
                            Tovább
                    </button>
                    <button 
                        type="submit"
                        className="kwizda-back-button"
                        onClick={(e)=>this.handleBackClick(e)}
                    >
                            Vissza
                    </button>
                </div>
                }
            </div> 
        );
    }
}
 
export default Regulations;